export default __webpack_public_path__ + "static/media/535.5b375028.gif";